var map = {
	"./ar.js": "./node_modules/@angular/common/locales/ar.js",
	"./en.js": "./node_modules/@angular/common/locales/en.js",
	"./extra/ar.js": "./node_modules/@angular/common/locales/extra/ar.js",
	"./extra/en.js": "./node_modules/@angular/common/locales/extra/en.js",
	"./extra/pa-Guru.js": "./node_modules/@angular/common/locales/extra/pa-Guru.js",
	"./extra/ru.js": "./node_modules/@angular/common/locales/extra/ru.js",
	"./global/ar.js": "./node_modules/@angular/common/locales/global/ar.js",
	"./global/en.js": "./node_modules/@angular/common/locales/global/en.js",
	"./global/pa-Guru.js": "./node_modules/@angular/common/locales/global/pa-Guru.js",
	"./global/ru.js": "./node_modules/@angular/common/locales/global/ru.js",
	"./pa-Guru.js": "./node_modules/@angular/common/locales/pa-Guru.js",
	"./ru.js": "./node_modules/@angular/common/locales/ru.js"
};


function webpackAsyncContext(req) {
	return webpackAsyncContextResolve(req).then(function(id) {
		return __webpack_require__.t(id, 7);;
	});
}
function webpackAsyncContextResolve(req) {
	return __webpack_require__.e(/*! lazy-once context | i18n-extra */ "i18n-extra").then(function() {
		if(!__webpack_require__.o(map, req)) {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		}
		return map[req];
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.resolve = webpackAsyncContextResolve;
webpackAsyncContext.id = "./node_modules/@angular/common/locales lazy-once recursive ^\\.\\/.*\\.js$ include: (ru|en|ar)\\.js$";
module.exports = webpackAsyncContext;